import create from 'zustand';

const [useSnackBarStore, apiSnackBarStore] = create(set => ({
	isSnackBarActive: false,
	snackBar: null,
	showSnackBar: ({
		theme, message, status, timeout = 2500
	}) => {
		set({ isSnackBarActive: true, snackBar: { theme, message, status } });
		setTimeout(() => set({ isSnackBarActive: false }), timeout);// Hide after 1.5s by default
	}
}));

export { apiSnackBarStore };
export default useSnackBarStore;
